export const COLUMN_FILTER_PAYLOAD_MAP = {
  "Enhance Workflow": {
    episodeId: "episode_identifier",
    fileName: "file_type",
    healthFund: "insurer_identifier",
    diagnosis: "principal_diagonsis",
    currentDrg: "drg",
    coderName: "coder_name",
    auditStatus: "status",
    auditRuleCategory: "audit_rule_category",
    auditRuleRefNo: "audit_ref_no",
    speciality: "case_mix_speciality",
    priority: "priority_value",
    drgVersion:"version",
    procedureDiagnosis:"procedure_codes",
    mrn:"medical_record_number",
    careType:"care_type",
    assignedTo: "assigned_to",
    auditUserMessage:"user_message",
    auditLongDescription:"long_description",
    auditShortDescription:"short_description",
    admitDate: {
      from: "admission_date_from",
      to: "admission_date_to",
    },
    dischargeDate: {
      from: "separation_date_from",
      to: "separation_date_to",
    },
    los: {
    operator: "los_op",
    value: "length_of_stay",
  },
  },

  "Combined Review": {
    episodeId: "episode_identifier",
    fileName: "file_name",
    healthFund: "health_fund",
    diagnosis: "principal_diagnosis",
    currentDrg: "actual_drg",
    coderName: "coder_name",
    auditRuleRefNo: "audit_rule_ref_no",
    speciality: "speciality",
    assignedTo: "assigned_to",
    priority: "priority",
    // codeEnhancePriority: "pallas_priority",
    pallasPriority: "pallas_priority",
    // priorityValue: "priority_value",
    drgVersion:"version",
    principalProcedureCode:"procedure_code",
    principalDiagnosis:"principal_diagnosis",
    actualDrg:"actual_drg",
    predictedDrg1: "predicted_drg1",
    predictedDrg2: "predicted_drg2",
    mrn:"medical_record_number",
    auditStatus: "status",
    careType: "care_type",
     auditUserMessage:"user_message",
     auditLongDescription:"long_description",
     auditShortDescription:"short_description",
      admitDate: {
      from: "admission_date_from",
      to: "admission_date_to",
    },
    dischargeDate: {
      from: "separation_date_from",
      to: "separation_date_to",
    },
    los: {
    operator: "los_op",
    value: "length_of_stay",
  },

  },
    "Enhance Plus Workflow": {
    episodeId: "episode_id",
    mrn:"medical_record_number",
    speciality: "speciality",
    actualDrg: "actual_drg",
    predictedDrg1: "predicted_drg1",
    predictedDrg2: "predicted_drg2",
    diagnosis: "principal_diagnosis",
    healthFund: "health_fund_identifier",
    auditRuleRefNo: "audit_rule_reference_no",
    codeEnhancePriority: "code_enhance_priority",
    priorityValue: "priority_value",
    healthFund: "health_fund_identifier",
    principalDiagnosis: "principal_diagnosis",
    auditStatus: "status",
    principalProcedureCode:"principal_procedure_code",
    drgVersion:"version",
    assignedTo: "assigned_to",
    careType: "care_type",
    auditUserMessage:"user_message",
    auditLongDescription:"long_description",
    auditShortDescription:"short_description",
     admissionDate: {
      from: "admission_date_from",
      to: "admission_date_to",
    },
    separationDate: {
      from: "separation_date_from",
      to: "separation_date_to",
    },
    los: {
    operator: "los_op",
    value: "length_of_stay",
  },
  },

};
export const STATIC_FILTER_OPTIONS = {
  "Enhance Plus Workflow": {
    codeEnhancePriority: ['P1', 'P2', 'P3', 'P4', 'P5'],
    priorityValue: ['Ultra High', 'High', 'Medium', 'Low'],
    drgVersion: {
      options: ["6", "8", "10", "11","12"],
      type: 'radio'
    }
  },
  "Enhance Workflow": {
    codeEnhancePriority: ['P1', 'P2', 'P3', 'P4', 'P5'],
    priority: ['P1', 'P2', 'P3', 'P4', 'P5'],
    drgVersion: {
      options: ["6", "8", "10", "11","12"],
      type: 'radio'
    }
  },
    "Combined Review": {
    priority: ['P1', 'P2', 'P3', 'P4', 'P5'],
    codeEnhancePriority: ['P1', 'P2', 'P3', 'P4', 'P5'],
    pallasPriority: ['Ultra High', 'High', 'Medium', 'Low'],
    priorityValue: ['Ultra High', 'High', 'Medium', 'Low'],
    drgVersion: {
      options: ["6", "8", "10", "11","12"],
      type: 'radio'
    }
  },
};


export const SORT_KEY_MAP = {
  // Common
  priority: "priority_value",
  pallasPriority: "pallas_priority",
  codeEnhancePriority: "code_enhance_priority",
  priorityValue: "priority_value",

  episodeId: "episode_id",
  mrn: "medical_record_number",
  dob: "date_of_birth",
  age: "age",
  sex: "sex",

  // Dates
  admitDate: "admission_date",
  dischargeDate: "separation_date",
  admissionDate: "admission_date",
  separationDate: "separation_date",

  // LOS
  los: "los",

  // Clinical
  diagnosis: "principal_diagnosis",
  currentDrg: "actual_drg",
  actualDrg: "actual_drg",
  predictedDrg1: "predicted_drg1",
  predictedDrg2: "predicted_drg2",
  drgVersion: "drg_version",
   procedureDiagnosis: "procedure_codes",
   additionalDiagnosis:"additional_diagnoses",
   principalDiagnosis:"principal_diagnosis",
   principalProcedureCode:"principal_procedure_code",
  // Audit
  auditStatus: "status",
  auditRuleCategory: "audit_rule_category",
  auditRuleRefNo: "audit_rule_reference_no",
  auditShortDescription: "short_description",
   auditLongDescription: "long_description",
   auditUserMessage: "user_message",

  // Financial
  currentDrgRevenue: "previous_drg_revenue",
  auditDrgRevenue: "audit_drg_revenue",
  actualReimbursement: "actual_reimbursement",
  predictedReimbursement1: "predicted_reimbursement1",
  predictedReimbursement2: "predicted_reimbursement2",
  delta1: "delta1",
  delta2: "delta2",
  predictedWeight1: "predicted_weight1",
  predictedWeight2: "predicted_weight2",

  // Patient / Hospital
  healthFund: "health_fund",
  hospitalType: "hospital_type",
  careType: "care_type",
  speciality: "speciality",
  sourceofReferral: "source_of_referral",
  modeofSeparation: "mode_of_separation",

  // Administrative
  fileName: "file_name",
  coderName: "coder_name",
  loadID: "load_id",
  createdAt: "created_at",
  
  predictedDrg2Path:"predicted_drg2_path",
  predictedDrg1Path:"predicted_drg1_path",
  assignedTo:"assigned_to"

};

export const formatDate = (date) => {
  if (!date) return "";
  const [year, month, day] = date.split("-");
  return `${day}-${month}-${year}`;
};

